import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  FaMapMarkerAlt,
  FaBuilding,
  FaPen,
  FaEye,
  FaTrash,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FiPlus, FiFilter } from "react-icons/fi";
import CompanyViewModal from "./CompanyViewModal";
import Loader from "./Loader";
import ConfirmActionModal from "./ConfirmActionModal"; // <- import your new modal
// import ConnectedDirectoryModal from "./ConnectedDirectoryModal";
import API from "../../utils/api";
import { BASE_URL } from "../../utils/api";
import RequestDirectoryModal from "../CompanyAdmin/RequestDirectoryModal";
const CompanyList = () => {
  const [companies, setCompanies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const companiesPerPage = 9;
  const [showDirectoryModal, setShowDirectoryModal] = useState(false);
  const [directoryCompany, setDirectoryCompany] = useState(null);
  const token = localStorage.getItem("token");
  const payload = JSON.parse(atob(token.split(".")[1])); // decode JWT
  const userRole = payload.role;
  const userId = payload._id || payload.id;
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleting, setDeleting] = useState(false); // 👈 new state
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [requestCompany, setRequestCompany] = useState(null);
const [infoModal, setInfoModal] = useState({
  isOpen: false,
  title: "",
  message: "",
});

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    confirmText: "",
    onConfirm: () => { },
  });
  const openRequestModal = (company) => {
    setRequestCompany(company);
    setShowRequestModal(true);
  };

  const closeRequestModal = () => {
    setShowRequestModal(false);
    setRequestCompany(null);
  };

  const handleAddCompany = () => {
    setConfirmModal({
      isOpen: true,
      title: "Confirm Add",
      message: "Are you sure you want to add a new company?",
      confirmText: "Yes, Add",
      confirmColor: "blue",
      onConfirm: () => {
        setConfirmModal({ ...confirmModal, isOpen: false });
        if (userRole === "super_admin") {
          navigate("/admin/create-company");
        } else {
          navigate("/company/create-company");
        }
      },
    });
  };
  const handleViewCompany = (company) => {
    setSelectedCompany(company);
    setIsModalOpen(true);
  };
  const handleDeleteClick = (company) => {
    setConfirmModal({
      isOpen: true,
      title: "Confirm Delete",
      message: (
        <span>
          Are you sure you want to delete{" "}
          <span className="text-red-600 font-semibold">"{company.name}"</span>?
        </span>
      ),
      confirmText: "Yes, Delete",
      confirmColor: "red",
      onConfirm: async () => {
        setDeleting(true); // 👈 show loader
        try {
          await API.delete(`/companies/${company._id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setCompanies((prev) => prev.filter((c) => c._id !== company._id));
        } catch (error) {
          console.error("Error deleting company:", error);
        } finally {
          setDeleting(false); // 👈 hide loader
          setConfirmModal({ ...confirmModal, isOpen: false });
        }
      },
    });
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCompany(null);
  };
  const navigate = useNavigate();
  const handleDirectory = (company) => {
    setDirectoryCompany(company);
    setShowDirectoryModal(true);
  };
  useEffect(() => {
  const connectedCompanyId = localStorage.getItem("google_connected_company");

  if (!connectedCompanyId) return;

  const company = companies.find((c) => c._id === connectedCompanyId);
  if (!company) return;

  const googleAuth = company?.socialMedia?.googleAuth;

  if (googleAuth?.accessToken && googleAuth?.isConnected) {
  setInfoModal({
    isOpen: true,
    title: "Google Connected",
    message: "✅ Connected to Google successfully!",
  });
}
 else if (googleAuth?.accessToken && !googleAuth?.isConnected) {
   setInfoModal({
  isOpen: true,
  title: "Google Connection Failed",
  message: "⚠️ No Google listing found. Please request one.",
});

  }

  localStorage.removeItem("google_connected_company");
}, [companies]);

useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const connected = urlParams.get("connected");
  const companyId = urlParams.get("companyId");

  if (connected === "google" && companyId) {
    localStorage.setItem("google_connected_company", companyId);

    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
  }
}, []); // ✅ your existing effect

useEffect(() => {
  const connectedCompanyId = localStorage.getItem("google_connected_company");
  if (!connectedCompanyId) return;

  const company = companies.find((c) => c._id === connectedCompanyId);
  if (!company) return;

  const googleAuth = company?.socialMedia?.googleAuth;

  if (googleAuth?.accessToken && googleAuth?.isConnected) {
    alert("✅ Connected to Google successfully!");
  } else if (googleAuth?.accessToken && !googleAuth?.isConnected) {
    alert("⚠️ Google connection failed: No listing found. Please request one.");
  }

  localStorage.removeItem("google_connected_company");
}, [companies]); // ✅ this new one depends on companies


  // Fetch companies from backend
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const token = localStorage.getItem("token"); // adjust if you store it somewhere else

        console.log("token", userId);
        const response = await API.get("/companies", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("Companies API Response:", response.data);
        let allCompanies = response.data.data || [];

        if (userRole === "admin") {
          allCompanies = allCompanies.filter(company => company.createdBy === userId);
        }

        setCompanies(allCompanies);

      } catch (error) {
        console.error("Error fetching companies:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanies();
  }, []);

  const totalPages = Math.ceil(companies.length / companiesPerPage);
  const indexOfLast = currentPage * companiesPerPage;
  const indexOfFirst = indexOfLast - companiesPerPage;
  const currentCompanies = companies.slice(indexOfFirst, indexOfLast);
  const companiesLength = companies.length;

  const handleEditCompany = (companyId) => {
    if (userRole === "super_admin") {
      navigate(`/admin/edit-company/${companyId}`);
    } else {
      navigate(`/company/edit-company/${companyId}`);
    }
  };

  const paginate = (pageNum) => setCurrentPage(pageNum);

  return (
    <div className=" p-6 bg-white-100 min-h-screen shadow-lg rounded-lg">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-semibold text-gray-800">Companies</h2>
          <p className="text-gray-600">
            `In total <strong>{companiesLength}</strong> companies listed on the
            platform`
          </p>
        </div>
        <div className="flex gap-4">
          {(userRole === "super_admin" || userRole === "admin") && (
            <>
              <button
                onClick={handleAddCompany}
                className="bg-gray-900 text-white  px-4 py-2 rounded-full flex items-center gap-2 transition hover:bg-gray-700 transition"
              >
                <FiPlus /> Add
              </button>
            </>
          )}

          <button className="bg-white border border-gray-300 px-4 py-2 rounded-md flex items-center gap-2 text-gray-600 hover:bg-gray-100 transition">
            <FiFilter /> Filters
          </button>
        </div>
      </div>

      <>
        {/* Cards */}
        <div className="relative min-h-[300px]">
          {" "}
          {/* <- container with space for spinner */}
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center z-10">
              <div className=" p-4 ">
                <Loader message="Fetching companies..." />
              </div>
            </div>
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 opacity-100">
            {!loading &&
              currentCompanies.map((company, index) => (
                <div
                  key={company._id || index}
                  className="bg-white rounded-xl border border-gray-200 shadow-lg p-5 flex flex-col justify-between hover:shadow-xl transition-all duration-200 transform hover:scale-[1.02] transition-transform"
                >
                  {/* Top Section */}
                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-3">
                      <div className="w-11 h-11 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center text-lg font-bold overflow-hidden">
                        {company.media?.logo ? (
                          <img
                            src={`${BASE_URL}${company.media.logo}`} // replace with your actual backend domain if in prod
                            alt={company.name}
                            className="w-full h-full object-contain"
                          />
                        ) : (
                          company.name?.charAt(0)
                        )}
                      </div>

                      <div>
                        <h3 className="text-md font-semibold text-gray-900">
                          {company.name}
                        </h3>
                      </div>
                    </div>
                    <span
                      className={`text-xs px-3 py-1 rounded-full font-medium ${company.status === "active"
                        ? "bg-green-100text-[#8ec700]"
                        : "bg-green-100text-[#8ec700]"
                        }`}
                    >
                      Active
                    </span>
                  </div>

                  {/* Middle Info */}
                  <div className="mt-4 text-gray-600 text-sm flex items-center gap-2">
                    <FaMapMarkerAlt className="text-gray-600" />
                    {company.address?.street} {company.address?.city},{" "}
                    {company.address?.state}, {company.address?.country}
                  </div>

                  {/* Action Icons */}
                  <div className="flex justify-between items-center border-t pt-4 mt-6 text-gray-500">
                    {(userRole === "super_admin" || userRole === "admin")   && (
                      <>
                        {" "}
                        {/* <button
                          onClick={() => handleDirectory(company)}
                          className="text-blue-600 hover:text-blue-400 transition"
                        >
                          View Connected Directories
                        </button> */}
                        <button
                          onClick={() => openRequestModal(company)}
                          className="text-blue-600 hover:text-blue-400 transition"
                        >
                          Request Directory
                        </button>

                      </>
                    )}

                    <div className="flex justify-end gap-3 ml-2  text-gray-600 ">
                      {/* View model will opened up if this hads been cooment out */}
                      {/* <FaEye
                        className="cursor-pointer hover:text-gray-400"
                        title="View"
                        onClick={() => handleViewCompany(company)}
                      /> */}

                      {(userRole === "super_admin" ||
                        company.createdBy === userId) && (
                          <>
                            <FaPen
                              className="cursor-pointer hover:text-gray-400"
                              title="Edit"
                              onClick={() =>
                                setConfirmModal({
                                  isOpen: true,
                                  title: "Confirm Edit",
                                  message: (
                                    <span>
                                      Are you sure you want to edit{" "}
                                      <span className="text-gray-900 font-semibold">
                                        "{company.name}"
                                      </span>
                                      ?
                                    </span>
                                  ),
                                  confirmText: "Yes, Edit",
                                  confirmColor: "blue", // You can choose green/blue/purple etc.
                                  onConfirm: () => {
                                    setConfirmModal((prev) => ({
                                      ...prev,
                                      isOpen: false,
                                    }));
                                    handleEditCompany(company._id);
                                  },
                                })
                              }
                            />

                            <FaTrash
                              className="cursor-pointer hover:text-red-600"
                              title="Delete"
                              onClick={() => handleDeleteClick(company)}
                            />
                          </>
                        )}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* Pagination */}
        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex justify-center mt-8 gap-2">
            <button
              className="px-3 py-1 border rounded-md disabled:opacity-50"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                className={`px-3 py-1 border rounded-md ${currentPage === i + 1 ? "bg-purple-600 text-white" : ""
                  }`}
                onClick={() => paginate(i + 1)}
              >
                {i + 1}
              </button>
            ))}
            <button
              className="px-3 py-1 border rounded-md disabled:opacity-50"
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
        {isModalOpen && (
          <CompanyViewModal company={selectedCompany} onClose={closeModal} />
        )}
        {confirmModal.isOpen && (
          <ConfirmActionModal
            isOpen={confirmModal.isOpen}
            title={confirmModal.title}
            message={confirmModal.message}
            confirmColor={confirmModal.confirmColor}
            confirmText={confirmModal.confirmText}
            onCancel={() => setConfirmModal({ ...confirmModal, isOpen: false })}
            onConfirm={confirmModal.onConfirm}
          />
        )}
        <ConfirmActionModal
  isOpen={infoModal.isOpen}
  title={infoModal.title}
  message={infoModal.message}
  confirmText="OK"
  confirmColor="blue"
  onConfirm={() => setInfoModal({ ...infoModal, isOpen: false })}
  onCancel={() => setInfoModal({ ...infoModal, isOpen: false })}
   showCancelButton={false} 
/>

        {/* {showDirectoryModal && directoryCompany && (
          <ConnectedDirectoryModal
            isOpen={showDirectoryModal}
            onClose={() => {
              setShowDirectoryModal(false);
              setDirectoryCompany(null);
            }}
            company={directoryCompany}
          />
        )} */}
        {showRequestModal && requestCompany && (
          <RequestDirectoryModal
            isOpen={showRequestModal}
            onClose={closeRequestModal}
            company={requestCompany}
          />
        )}

        {deleting && (
          <div className="fixed inset-0 bg-white/50 backdrop-blur-sm flex items-center justify-center z-50">
            <Loader message="Deleting company..." />
          </div>
        )}

      </>
    </div>
  );
};

export default CompanyList;
